import { applyNavAccess, colomboHour, esc } from './utils.js';
import { initThemeControls } from './theme-ui.js';
import { syncScrollStrip } from './ux.js';

const DEPARTMENTS = ['tour', 'visa', 'ticket'];
const DEPARTMENT_LABELS = { tour: 'Tours', visa: 'Visa', ticket: 'Tickets' };

let clockTimer = null;

function showDepartmentScopeBar(agent) {
  return agent
    && agent.role !== 'admin'
    && agent.departments?.length
    && agent.departments.length < DEPARTMENTS.length;
}

function getDayPart(hour = colomboHour()) {
  if (hour < 12) return 'morning';
  if (hour < 17) return 'afternoon';
  return 'evening';
}

export function syncLauncherHeroTime() {
  const hero = document.getElementById('launcherHero');
  if (!hero) return;
  const part = getDayPart();
  hero.classList.remove('launcher-hero-morning', 'launcher-hero-afternoon', 'launcher-hero-evening');
  hero.classList.add(`launcher-hero-${part}`);
}

export function updateHeaderGreeting(agent) {
  if (!agent) return;
  const hour = colomboHour();
  const part = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
  const textEl = document.getElementById('greetingText');
  const nameEl = document.getElementById('greetingName');
  if (textEl) textEl.textContent = `${part},`;
  if (nameEl) {
    nameEl.textContent = agent.name;
    nameEl.style.color = agent.color || '#00AEEF';
    nameEl.style.setProperty('--greeting-glow', agent.color || '#00AEEF');
  }
  const launcherGreeting = document.getElementById('launcherGreetingPart');
  const launcherName = document.getElementById('launcherAgentName');
  if (launcherGreeting) launcherGreeting.textContent = `${part},`;
  if (launcherName) {
    launcherName.textContent = agent.name;
    launcherName.style.color = agent.color || '#00AEEF';
    launcherName.style.setProperty('--launcher-glow', agent.color || '#00AEEF');
  }
  const deptEl = document.getElementById('greetingDepts');
  if (!deptEl) return;
  if (showDepartmentScopeBar(agent)) {
    const depts = agent.departments || [];
    deptEl.classList.remove('hidden');
    deptEl.innerHTML = depts.map((d) => {
      const label = DEPARTMENT_LABELS[d] || d;
      const primary = d === agent.primary_department;
      return `<span class="dept-pill dept-pill-${esc(d)}${primary ? ' is-primary' : ''}">${esc(label)}</span>`;
    }).join('');
  } else {
    deptEl.classList.add('hidden');
    deptEl.innerHTML = '';
  }
  syncLauncherHeroTime();
}

export function renderLiveClock() {
  const el = document.getElementById('liveClock');
  if (!el) return;
  const now = new Date();
  const dateStr = now.toLocaleString('en-LK', {
    weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Asia/Colombo',
  });
  const parts = new Intl.DateTimeFormat('en-LK', {
    hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true, timeZone: 'Asia/Colombo',
  }).formatToParts(now);
  const get = (type) => parts.find((p) => p.type === type)?.value || '';
  const sec = get('second');
  const prevSec = el.dataset.sec;
  el.dataset.sec = sec;
  const secClass = prevSec !== sec ? ' clock-sec-tick' : '';
  el.innerHTML = `<span class="clock-date">${esc(dateStr)}</span><span class="clock-sep" aria-hidden="true">·</span><span class="clock-time">${esc(get('hour'))}:${esc(get('minute'))}:<span class="clock-sec${secClass}">${esc(sec)}</span>&nbsp;${esc(get('dayPeriod'))}</span>`;
  syncLauncherHeroTime();
}

export function startHeaderClock() {
  if (clockTimer || !document.getElementById('liveClock')) return;
  renderLiveClock();
  clockTimer = setInterval(renderLiveClock, 1000);
}

export function initPageChrome(agent) {
  applyNavAccess(agent);
  initThemeControls();
  updateHeaderGreeting(agent);
  startHeaderClock();
  // On phones the header actions collapse into one scrollable row.
  syncScrollStrip(document.querySelector('.header-actions'), null);
  syncScrollStrip(document.querySelector('.admin-nav'), '.sidebar-item.active');
}
